import React, { ReactNode, useReducer, useState } from 'react'
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
  Typography,
  useMediaQuery,
  Button,
} from '@mui/material'
import {fonts, theme} from '../../../config/Dashboardtheme'
import Pagination from '@mui/material/Pagination'
import arrowimage from '@meprism/shared/src/assets/icons/next.svg'
import ExposedDataModal from './ExposedDataModal'
import { HelpOutlineOutlined, ArrowUpward, ArrowDownward } from '@mui/icons-material'
import MultiSelectDropdown from './MultiSelectDropdown'
import { getCol4DisplayValue } from '../../../utils/helpers';
import { filterReducer, initialState } from '../../reducers/removalStatsReducer';

interface RemovalStatsModalProps {
  Brokers: any[]
  unmatchedBrokers: any[]
}

const RemovalStats = (props: RemovalStatsModalProps) => {
    const [filterState, dispatchFilterState] = useReducer(filterReducer, initialState);
    const accurateBrokersFilter = props.Brokers.filter(broker => broker.summary.accurate);
    const accurateBrokers = accurateBrokersFilter.reduce((acc: any, broker: any) => {
      const brokerName = broker.summary.broker_display_name ?? broker.summary.data_broker.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
      if (!acc[brokerName]) {
        acc[brokerName] = []
      }
      acc[brokerName].push(broker.summary)
      return acc
    }, {})
   
    const unmatchedBrokers = props.unmatchedBrokers
    const [page, setPage] = useState(0)
    const rowsPerPage = 5
    const rows = (Object.entries(accurateBrokers) as [string, any[]][])
    .map(([brokerName, brokerArray], index) => {
      const inProgressRecord = brokerArray.find((item: any) => !['removed', 'completed'].includes(item.status))
      if (inProgressRecord) {
        const hasPhones = inProgressRecord.detail?.phones?.length ?? 0 > 0
        const hasRelatives = inProgressRecord.detail?.relatives?.length ?? 0 > 0
        const email = inProgressRecord.detail?.emails?.length ?? 0 > 0
        const address = inProgressRecord.detail?.addresses?.length ?? 0 > 0
        const name = inProgressRecord.detail?.first_name
        const hasAge = inProgressRecord.detail?.age
        const col3Text = []

        if (name) {
          col3Text.push('Name')
        }
        if (hasPhones) {
          col3Text.push('Phone')
        }
        if (hasRelatives) {
          col3Text.push('Relatives')
        }
        if (hasAge) {
          col3Text.push('Age')
        }
        if (email) {
          col3Text.push('Email')
        }
        if (address) {
          col3Text.push('Address')
        }

        const brokerlength = brokerArray.length
        const dataBroker = brokerName

        return [
          {
            id: index + 1,
            col1: dataBroker,
            col2: brokerlength,
            col3: col3Text.join(', '),
            col4: 'new',
          },
        ]
      }

      const removedRecord = brokerArray.find((item: any) => ['removed', 'completed'].includes(item.status))
      if (removedRecord) {
        const hasPhones = removedRecord.detail?.phones?.length ?? 0 > 0
        const hasRelatives = removedRecord.detail?.relatives?.length ?? 0 > 0
        const email = removedRecord.detail?.emails?.length ?? 0 > 0
        const address = removedRecord.detail?.addresses?.length ?? 0 > 0
        const name = removedRecord.detail?.first_name
        const hasAge = removedRecord.detail?.age
        const col3Text = []

        if (name) {
          col3Text.push('Name')
        }
        if (hasPhones) {
          col3Text.push('Phone')
        }
        if (hasRelatives) {
          col3Text.push('Relatives')
        }
        if (hasAge) {
          col3Text.push('Age')
        }
        if (email) {
          col3Text.push('Email')
        }
        if (address) {
          col3Text.push('Address')
        }

        const brokerlength = brokerArray.length
        const dataBroker = brokerName

        return [
          {
            id: index + 1,
            col1: dataBroker,
            col2: brokerlength,
            col3: col3Text.join(', '),
            col4: 'removed',
          },
        ]
      }

      const brokerRows = brokerArray.map((item: any, subIndex: number) => {
        const hasPhones = item.detail?.phones?.length ?? 0 > 0
        const hasRelatives = item.detail?.relatives?.length ?? 0 > 0
        const email = item.detail?.emails?.length ?? 0 > 0
        const address = item.detail?.addresses?.length ?? 0 > 0
        const name = item.detail?.first_name
        const hasAge = item.detail?.age
        const col3Text = []

        if (name) {
          col3Text.push('Name')
        }
        if (hasPhones) {
          col3Text.push('Phone')
        }
        if (hasRelatives) {
          col3Text.push('Relatives')
        }
        if (hasAge) {
          col3Text.push('Age')
        }
        if (email) {
          col3Text.push('Email')
        }
        if (address) {
          col3Text.push('Address')
        }

        const brokerlength = brokerArray.length
        const dataBroker = brokerName

        return {
          id: index * rowsPerPage + subIndex + 1,
          col1: dataBroker,
          col2: brokerlength,
          col3: col3Text.join(', '),
          col4: item.status,
        }
      })
      return brokerRows
    })
    .flat()
    .filter(Boolean)

  const unmatchedBrokerRows = unmatchedBrokers?.map((value, index) => {
    return {
      id: rows.length + index + 1,
      col1: value,
      col2: 0,
      col3: 'None',
      col4: 'not_found',
    }
  })

  const isNotFoundStatus = (status: string) => status === 'not_found'

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isSmallDesktop = useMediaQuery(theme.breakpoints.down('lg'))

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage - 1)
  }
  const [openmodal, setopenmodal] = useState(false)
  const [selectedBrokerData, setSelectedBrokerData] = useState([])
  const handleOpenModal = (brokerData: any) => {
    setopenmodal(true)
    setSelectedBrokerData(brokerData)
  }
  const columns = [
    { key: 'col1', name: 'Data Brokers', resizable: true, width: 150 },
    { key: 'col2', name: 'Records found', resizable: true, width: 150 },
    { key: 'col3', name: 'Exposed Data', resizable: true, width: 150 },
    { key: 'col4', name: 'Status', resizable: true, width: 150 },
    { key: '', name: '', resizable: false, width: 50 },
  ]
  const allRows = unmatchedBrokerRows ? rows.concat(unmatchedBrokerRows) : rows
  const filteredRows = React.useMemo(() => {
    const normalizedSelectedStatus = filterState.searchFilters.statuses.flatMap(status =>
      status === 'optout_in_progress' ? ['optout_in_progress', 'new'] : [status]
    );
  
    return allRows.filter(row =>
      (filterState.searchFilters.brokers.length === 0 || filterState.searchFilters.brokers.includes(row.col1)) &&
      (normalizedSelectedStatus.length === 0 || normalizedSelectedStatus.includes(row.col4))
    );
  }, [allRows, filterState.searchFilters]);
  const sortedRows = React.useMemo(() => [...filteredRows].sort((a, b) => {
    const { key, direction } = filterState.sortConfig;
    if (!key) return 0;
    
    const rawA = a[key as keyof typeof a] as string;
    const rawB = b[key as keyof typeof b] as string;
    
    const formatValue = (val: string): string => {
      const str = String(val).toLowerCase();
      return key === 'col4' ? getCol4DisplayValue(str) : str;
    };

    const aVal = formatValue(rawA);
    const bVal = formatValue(rawB);


    return direction === 'asc'
      ? aVal.localeCompare(bVal)
      : bVal.localeCompare(aVal);
  }), [filteredRows, filterState.sortConfig]);
  const paginatedRows = sortedRows.slice(page * rowsPerPage, (page + 1) * rowsPerPage)
  const renderExposedData = (data: string) => {
    const returnedHtml: ReactNode[] = []
    let maxShownData = 4
    let currentIdx = 0
    const checkingKey = [
      'Name',
      'Age',
      'Address',
      'Phone',
      'Relatives',
      'Email',
      'None',
    ]
    const lenOfCheckingKey = checkingKey.length
    while (maxShownData && currentIdx < lenOfCheckingKey) {
      if (data.includes(checkingKey[currentIdx])) {
        returnedHtml.push(
          <Box
            key={maxShownData}
            sx={{
              background: '#EFEDFDB2',
              display: 'inline-block',
              padding: '4px',
              borderRadius: '4px',
              marginRight: '5px',
            }}>
            {checkingKey[currentIdx]}
          </Box>,
        )
        maxShownData -= 1
      }
      currentIdx += 1
    }
    return returnedHtml
  }
 
  const statusOptions = [
    { label: 'Not Found', value: 'not_found' },
    { label: 'Removing', value: 'optout_in_progress'},
    { label: 'Removed', value: 'removed' },
  ];
  
  const brokerOptions = [
    ...Object.keys(accurateBrokers || {}).map(key => ({ label: key, value: key })),
    ...(unmatchedBrokers || []).map(broker => ({ label: broker, value: broker }))
  ];

  const handleSearch = () => {
    setPage(0)
    dispatchFilterState({
      type: 'SET_FILTERS',
      payload: {
        brokers: filterState.selectedBroker,
        statuses: filterState.selectedStatus,
      },
    });
  }
  const handleSort = (columnKey: string) => {
    dispatchFilterState({
      type: 'SET_SORT',
      payload: (() => {
        if (filterState.sortConfig.key === columnKey) {
          return {
            ...filterState.sortConfig,
            direction: filterState.sortConfig.direction === 'asc' ? 'desc' : 'asc',
          };
        }
        return {
          key: columnKey,
          direction: 'asc',
        };
      })(),
    });
  }
  return (
    <ThemeProvider theme={theme}>
      {!isMobile ? (
        <>
        {/* Search Bar */}
          <Box sx={{ display: 'flex', justifyContent: 'center'}}>
           <Box sx={{ mb: 3, py: 8, px:3, bgcolor: 'transparent', borderRadius: 2, width: '100%' }}>
           <Grid container spacing={2} alignItems="center">
             {/* Broker*/}
             <Grid item xs={12} sm={5}>
                <MultiSelectDropdown
                  options={brokerOptions}
                  onChange={(newValue)=>{dispatchFilterState({ type: 'SET_BROKER', payload: newValue })}}
                  value={filterState.selectedBroker}
                  label="Data Broker"
                  limitTags={isSmallDesktop ? 1 : 2}
                  maxLength={14}
                />
              </Grid>

              {/*Status*/}
              <Grid item xs={12} sm={5}>
                <MultiSelectDropdown
                  options={statusOptions}
                  onChange={(newValue)=>{dispatchFilterState({ type: 'SET_STATUS', payload: newValue })}}
                  value={filterState.selectedStatus}
                  label="Status"
                  limitTags={isSmallDesktop ? 1 : 3}
                  maxLength={20}
                />  
              </Grid>
              {/*Search button*/}
              <Grid item xs={12} sm={2}>
                <Button 
                  sx={{
                    width: '100%', 
                    minHeight: '50px', 
                    fontFamily: 'InterMedium',
                    background:'rgb(66, 107, 240)',
                    color:'#fff',
                    border:'none',
                    fontSize: {sm: '13px', md: '16px'},
                    '&:hover':{
                      background:'rgb(66, 107, 240)',
                      color:'#fff'
                    }
                  }} 
                  variant="contained" 
                  onClick={handleSearch}>
                  Search
                </Button>
              </Grid>
            </Grid>
            </Box>
          </Box>

        {/* Table */}
          <Box
            style={{ height: 'auto', width: '100%', paddingBottom: '16px' }}
            bgcolor="#fff"
            borderRadius={5}
            p={3}>
            <TableContainer>
              <Table
                style={{
                  background: '#fff',
                  color: '#040115',
                  borderRadius: 5,
                  padding: 3,
                  tableLayout: 'fixed',
                }}>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.key}
                        style={{
                          borderBottom: '1px solid #9135E0',
                          ...fonts.Inter.SemiBold,
                          width: column.width,
                        }}>
                        {column.name}
                        {column.name === 'Records found' && (
                          <Tooltip title="A data broker can create multiple records or profiles of you using your data">
                            <IconButton>
                              <HelpOutlineOutlined
                                sx={{
                                  fontSize: '16px',
                                  color: 'rgba(145, 53, 224, 1)',
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                        {(['col1', 'col4'].includes(column.key)) && (
                          <IconButton size="small" onClick={()=> handleSort(column.key)}>
                            {filterState.sortConfig.key === column.key && filterState.sortConfig.direction === 'desc' ? (
                              <ArrowUpward sx={{ fontSize: '16px', color: 'rgba(145, 53, 224, 1)' }} />
                            ) : (
                              <ArrowDownward sx={{ fontSize: '16px', color: 'rgba(145, 53, 224, 1)' }} />
                            )}
                          </IconButton>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginatedRows.length === 0 ? (
                     <TableRow>
                     <TableCell colSpan={columns.length} style={{ textAlign: 'center' }}>
                       {allRows.length === 0 ? (
                         'Scanning in progress'
                       ) : (
                         'No profiles match these criteria'
                       )}
                     </TableCell>
                   </TableRow>
                  ):
                  (
                  paginatedRows.map((row) => (
                    <TableRow key={row.id}>
                      {columns.map((column) => (
                        <TableCell
                          onClick={() => {
                            const brokerData = accurateBrokers[row.col1]
                            if (!isNotFoundStatus(row.col4)) {
                              handleOpenModal(brokerData)
                            }
                          }}
                          key={column.key}
                          style={{
                            borderBottom: '1px solid rgba(97, 95, 107, 0.5)',
                            // textTransform: column.key === 'col1' ? 'capitalize' : 'none',
                            width: column.width,
                          }}>
                          {column.key === '' && !isNotFoundStatus(row.col4) ? (
                            <img
                              src={arrowimage}
                              alt="Arrow"
                              style={{ width: '20px', height: '20px' }}
                            />
                          ) : column.key === 'col1' ? (
                            `${row.col1}`
                          ) : column.key === 'col3' ? (
                            <>{renderExposedData(row.col3)}</>
                            ) : column.key === 'col4' ? (
                              isNotFoundStatus(row.col4) ? (
                                <span style={{ color: '#E2B93B' }}>Not Found</span>
                              ) :

                              <span
                                style={{
                                  color: ['optout_in_progress', 'new'].includes(
                                    row.col4,
                                  )
                                    ? '#E2B93B'
                                    : '#EB5757',
                                }}>
                                {
                                  ['optout_in_progress', 'new'].includes(
                                    row.col4,
                                  )
                                    ? 'Removing'
                                    : 'Removed' // Adjust with actual status names
                                }
                              </span>

                          ) : (
                            row[column.key as keyof typeof row]
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                  )
                }
                </TableBody>
              </Table>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 2,
                  padding: 2,
                  borderRadius: 5,
                  background: '#fff',
                }}>
                <Pagination
                  variant="outlined"
                  shape="rounded"
                  count={Math.ceil(sortedRows.length / rowsPerPage)}
                  page={page + 1}
                  onChange={handleChangePage}
                />
              </Box>
            </TableContainer>
          </Box>
        </>
      ) : (
        <Box
          style={{ height: 'auto', width: '100%' }}
          bgcolor="#fff"
          borderRadius={5}
          p={3}>
          <Typography variant="h3" mx={2} mt={2} mb={5}>
            Removal Stats({allRows.length})
          </Typography>

          {allRows.map((row) => (
            <Grid
              key={row?.id}
              container
              direction="row"
              spacing={2}
              sx={{
                borderBottom: '1px solid #615F6B',
                padding: 2,
                position: 'relative',
              }}>
              {columns.map((col) => (
                <Grid
                  item
                  key={col.key}
                  xs={6}
                  onClick={() => {
                    if (row) {
                      const brokerData = accurateBrokers[row.col1]
                      if (!isNotFoundStatus(row.col4)) {
                        handleOpenModal(brokerData)
                      }
                    }
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'left',
                      wordWrap: 'break-word',
                    }}>
                    {col.key !== '' && (
                      <Typography variant="h5">{col.name}:</Typography>
                    )}

                    {col.key === 'col3' ? (
                      <Typography variant="label">
                        {renderExposedData(
                          row?.col3 !== undefined ? row.col3 : '',
                        )}
                      </Typography>
                    ) : col.key === 'col4' ? (
                        <Typography
                          variant="label"
                          color={
                            [
                              'optout_in_progress',
                              'new',
                              'waiting_for_verification',
                            ].includes(row?.col4 || '')
                              ? '#E2B93B'
                              : isNotFoundStatus(row.col4) ? '#E2B93B' : '#EB5757'
                          }>
                          {
                            [
                              'optout_in_progress',
                              'new',
                              'waiting_for_verification',
                            ].includes(row?.col4 || '')
                              ? 'Removing'
                              : isNotFoundStatus(row.col4) ? 'None' : 'Removed' // Adjust with actual status names
                          }
                        </Typography>

                    ) : (
                      <Typography
                        variant="label"
                        {...(col.key === 'col2' ? { sx: { textAlign: 'center', width: '100%' } } : {})}
                      >
                        {' '}
                        {row?.[col.key as keyof typeof row]}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
              {!isNotFoundStatus(row.col4) && (
                <Box>
                  {' '}
                  <img
                    src={arrowimage}
                    alt="Arrow"
                    onClick={() => {
                      if (row) {
                        const brokerData = accurateBrokers[row.col1]
                        handleOpenModal(brokerData)
                      }
                    }}
                    style={{
                      marginBottom: '2rem',
                      width: '20px',
                      height: '20px',
                      position: 'absolute',
                      bottom: '0',
                      right: '0',
                    }}
                  />
                </Box>
              )}
            </Grid>
          ))}
        </Box>
      )}
      <ExposedDataModal
        rows={selectedBrokerData}
        open={openmodal}
        setOpen={setopenmodal}
      />
    </ThemeProvider>
  )
}

export default RemovalStats
